
import TimerLoadingBar from './timer-loading-bar.vue'
import { Options } from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { LobyListItemMixin } from './list-item-mixin'
import SvgMap from '@/components/roadmap/svg-map.vue'

@Options({
    components: {
        TimerLoadingBar,
        'svg-map': SvgMap
    }
})
export default class DListItemView extends Mixins(LobyListItemMixin) { }
